<template>
    <div v-if="previewData">
        <div v-for="item in previewData" :key="item._id" class="preview-wrapper">
            <div><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" width="16px" height="16px" viewBox="0 0 16 16" version="1.1">
                <title>{{item.task_type}}</title>
                <defs/>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
                <g id="bug" sketch:type="MSArtboardGroup">
                <g id="Bug" sketch:type="MSLayerGroup" transform="translate(1.000000, 1.000000)">
                <rect id="Rectangle-36" :fill="getTaskColor(item)" sketch:type="MSShapeGroup" x="0" y="0" width="14" height="14" rx="2"/>
                <path d="M10,7 C10,8.657 8.657,10 7,10 C5.343,10 4,8.657 4,7 C4,5.343 5.343,4 7,4 C8.657,4 10,5.343 10,7" id="Fill-2" fill="#FFFFFF" sketch:type="MSShapeGroup"/>
                </g>
                </g>
                </g>
            </svg></div>
            <div style="margin: 2px 7px 0px 2px;display: flex;flex:none" class="task-tag">
                <a v-if="isPreviewRequiredInSameTab == false" class="aaaaaa" :href="sentenceWithUrl.includes('/task/')?sentenceWithUrl+'/de?editMode=true':sentenceWithUrl" target="_blank">{{item.task_tag}}</a>

                <!-- <router-link v-else-if="!disbaleRedirect" :to="{ name: checkIfTask(item)?'tasks-window':'update-ticket', params: { taskId: item.task_tag , tabType:'cm', parentinfo:Object.assign({forceRedirect:true},$route)}, query:Object.assign({}, ...getProjectId(item.url).query)}">{{item.task_tag}}</router-link> -->
                <!--<router-link v-else-if="!disbaleRedirect" :to="{ name: 'tasks-window', params: { taskId: item.task_tag , tabType:'cm', parentinfo:Object.assign($route)}, query:Object.assign({editMode:true})}">{{item.task_tag}}</router-link>--> <!--routing fix -->
                <div class="task-preview-click" @click="handleTaskPreviewClick({ name: 'tasks-window', params: { taskId: item.task_tag , tabType:'cm', parentinfo:Object.assign($route)}, query:Object.assign({editMode:true})})" v-else-if="!disbaleRedirect"> {{item.task_tag}}</div>

                <!-- <router-link v-else-if="!disbaleRedirect" :to="{ name: checkIfTask(item)?'task-info':'update-ticket', params: { taskId: item.task_tag , tabType:'cm', parentinfo:Object.assign({forceRedirect:true},$route)}, query:Object.assign({}, getProjectId(item.url).query)}">{{item.task_tag}}</router-link> -->
                <a v-else>{{item.task_tag}}</a>
            </div>
            <!-- <a :href="item.url">{{item.task_tag}}</a> -->
            <div class="title-styles" :title="'Assigned to: '+item.title">{{item.title}}</div>
            <div v-if="item.assignee_name" :title="item.assignee_name" style="display: flex;align-items: center;margin: 6px 4px 0px 7px;">
                <div v-if="getProfileImageCheck(item.assignee_profile_image)" class='user-name-or-image'>
                    <img :src="getThumbnailConvertedPath(Object.prototype.toString.call(item.assignee_profile_image) == '[object Object]'?Object.values(item.assignee_profile_image)[0]:item.assignee_profile_image)" @error="replaceWithUserIcon($event)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px">
                </div>
                <div v-else class="user-name-or-image user-name" :style="style(item.assignee_name)">{{ item.assignee_name.split("")[0] }}
                </div>
                <!-- <div>{{item.assignee_name}}</div> -->
            </div>
            <div v-if="item.status_type!='New'" :title="item.status_type" style="margin: 2px 2px 0px 5px;" v-html="getStatusIcon(item.status_type)"></div>
            <div v-else style="margin: 0px 4px 0px 5px;color:#ababab"> {{item.status_type}}</div>
            </div>
        </div>
</template>

<script>
import {mapActions , mapGetters} from "vuex";
import Utils from "../../components.utils";

export default ({
    props:["sentenceWithUrl","previewDataFromParent","disbaleRedirect", "isPreviewRequiredInSameTab"],
    data(){
        return {
            previewUrl:null,
            previewData:[]
        }
    },
    methods:{
        ...mapActions("PAM", ["getServerIndTaskData"]),
        ...mapGetters("registry",["getRegisteredPluginMapper"]),
         getThumbnailConvertedPath(image_url){
            return Utils.convertToLoginIPDomainName(image_url);
         },
         async handleTaskPreviewClick(routeInfo){
                const loadPAMplugin = async()=>{
                        return new Promise((resolve)=>{
                            let pamPlugin = null;
                            for(let pluginId in this.getRegisteredPluginMapper()){
                                pamPlugin = this.getRegisteredPluginMapper()[pluginId];
                                if(pamPlugin && pamPlugin.name == 'PAM'){
                                    break;
                                }
                            }
                            if(pamPlugin && pamPlugin.getAlldependentPluginBundles){
                                pamPlugin.getAlldependentPluginBundles(()=>resolve());
                            }else{
                                resolve();
                            }
                        });
                }

                await loadPAMplugin();
                this.$router.push(routeInfo);
        },
        getTaskColor(task){
            if (task.task_type === 'Issue') {
                return '#E5493A'; // red -for issues
            }

            if ('parent_id' in task && task.task_type === 'Task') {
                return '#40571d'; // light green - for subtask
            }

            if (!('parent_id' in task) && task.task_type === 'Task') {
                return '#008000'; // dark green - For task
            }

            return '#03a8cd'; // default blue - For ticket
        },
        style(name){
            let style = {
                'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
                'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
            }
            return style
        },
        getProfileImageOfUser(image){
            let defaultImage = Utils.getNoThumbnailImg()
            if(Object.prototype.toString.call(image) == '[object Object]'){
                let profileImageTag = '<img src='+this.getProxyConvertedURL(Object.values(image)[0])+' onerror="this.src='+defaultImage+'; this.onerror = null"  style="width:100%;height:100%;border-radius:6px">'
                return profileImageTag;
            }else if(Object.prototype.toString.call(image) == '[object String]'){
                let profileImageTag = '<img src='+this.getProxyConvertedURL(image)+' onerror="this.src='+defaultImage+'; this.onerror = null"  style="width:100%;height:100%;border-radius:6px">'
                return profileImageTag;
            }
        },
        replaceWithUserIcon(e){
            e.target.onerror = null
            e.target.src = Utils.getNoThumbnailImg();
        },
        getProjectId(urlPath){
            let url = new URL(urlPath);
            urlPath = urlPath.replace(url.origin, "");
            let urlpathObj = this.$router.resolve({path:urlPath});
            return {query:urlpathObj.resolved.query, params:urlpathObj.resolved.params};
        },
        checkIfTask(cloneData){
            if (cloneData.task_type != "Ticket"){
                return true
            }
            return false
        },
        getProjectIdData(text){
            let urlRegex = /(https?:\/\/[^\s<>"'&]+)/gm;
            let temp = '',link='', arr = [];
                text.replace(urlRegex, function(url) {
                    temp = url;
                    link = url;
                    if(!(arr.includes(temp))){
                        arr.push(temp)
                    }
                })
                this.previewData = []; 
                for(let i = 0; i < arr.length; i++){
                    let checkUrl = arr[i].split("?");
                    let item = checkUrl[0].split("/");
                    let id = null;
                    if(item.includes("de") || item.includes("cm")){
                        if(item.indexOf("de") == item.length - 1 || item.indexOf("cm") == item.length - 1){
                            id = item[item.length-2]
                        }else{
                            id = item[item.length-3]
                        }
                    }else{
                        id = item[item.length-1];
                    }
                    if(id){
                        let payload = {};
                        payload["taskId"] = id;
                        if(item.indexOf('ticket').length > 0){
                           payload.taskType = "Ticket";
                        }
                        this.getServerIndTaskData(payload).then((data) =>{
                            if(data['task']){
                                data['task']['url'] = link;
                                this.previewData.push(data["task"]);
                                
                                this.$emit(
                                    "previewLoaded",
                                    true
                                );
                            }else {
                                this.$emit(
                                    "previewLoaded",
                                    false
                                );
                            }
                        }).catch(() => {
                            this.$emit(
                                "previewLoaded",
                                false
                            );

                        });
                    }
                }
        },
        getStatusIcon(status){
            // let statusIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus" viewBox="0 0 16 16">
            //                     <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
            //                 </svg>`;

            let statusIcon = "New";
            if(status == "In Progress"){
                statusIcon = `<svg data-v-976a8266="" xmlns="http://www.w3.org/2000/svg" width="14" height="16" fill="orange" viewBox="0 0 16 16" class="bi bi-clock-fill"><path data-v-976a8266="" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"></path></svg>`;
                
            }else if(status == "Done"){
                statusIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" fill="#57af57" viewBox="0 0 16 16" class="bi bi-check-circle-fill"><path data-v-976a8266="" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"></path></svg>`;
            }

            return statusIcon;
        },
        getProfileImageCheck(image){
            if(Object.prototype.toString.call(image) == '[object Object]' && Object.values(image)[0]){
                return true;
            }else if(Object.prototype.toString.call(image) == '[object String]' && image.length){
                return true;
            }else{
                return false;
            }
        },
    },
    created(){
        if(this.previewDataFromParent){
            this.previewData = [this.previewDataFromParent];
        }else if(this.sentenceWithUrl){
            this.previewUrl = this.sentenceWithUrl;
            this.getProjectIdData(this.previewUrl)
        }
    }
})
</script>


<style scoped lang="scss">
  $border-color: 1px solid #4a4a4a;
  $brighter-border: 1px solid #5a5a5a;
  $primary-background: #1a1e21;
  $secondary-background-color:#15181B;
  $bg-color-on-hover: #22272b;
  $text-color: #eee;
  $dull-text-color: #757575;
  $secondary-text-color: #9c9c9c;
  $active-blue : #007bff;
  $input-field-and-label-font-size:14px;
  $input-field-height:38px;
  $highlight-font-color:#ff9800;
  $scrollbar-thumb-background:#333;
  $scrollbar-track-background:#1a1e21;
  $scrollbar-thumb-on-hover-background:#555;
  $secondary-border-color: 1px solid #2b2b2b;
  $tags-background-color:#282d31;
  $tags-border-color:#363636;
  $input-field-padding:.375rem 10px;
  $tag-color: #18a6db;
    .preview-wrapper{
        display: flex;
        border: $brighter-border;
        padding: 5px;
        max-width: 90%;
        width: fit-content;
        border-radius: 4px;
        background: transparent;
        margin-top:5px;
        align-items: center;
        justify-content: space-around;
        .title-styles{
            white-space: nowrap;
            max-width: 82%;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-top: 2px;
        }
    }
    .task-tag{
            color:$tag-color;
        a{
            color:$tag-color;
        }
        a:hover,div.task-preview-click:hover{
            color:$tag-color;
            text-decoration: underline;
        }
    }
</style>